import React, { useState } from 'react';
import './ModalRecuperarProgresso.css';

const ModalRecuperarProgresso = ({
  recoveryState,
  onSubmitId,
  onApplyCloud,
  onKeepLocal,
  onCancel,
}) => {
  const [inputId, setInputId] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!recoveryState) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await onSubmitId(inputId);
    setLoading(false);
    if (result?.error) setError(result.error);
  };

  return (
    <div className="modal-recovery-overlay" onClick={onCancel}>
      <div className="modal-recovery-box" onClick={(e) => e.stopPropagation()}>

        {recoveryState.step === 'input' && (
          <>
            <h2 className="modal-recovery-title">Recuperar meu progresso</h2>
            <p className="modal-recovery-desc">
              Informe o seu <strong>ID de usuário</strong> para carregar seu álbum de outro dispositivo.
            </p>
            <form onSubmit={handleSubmit} className="modal-recovery-form">
              <input
                className="modal-recovery-input"
                type="text"
                placeholder="Ex: abc1-23de"
                value={inputId}
                onChange={(e) => setInputId(e.target.value.toLowerCase())}
                autoFocus
                autoCapitalize="none"
                autoCorrect="off"
                spellCheck={false}
              />
              {error && <p className="modal-recovery-error">{error}</p>}
              <div className="modal-recovery-actions">
                <button type="button" className="btn-secondary" onClick={onCancel} disabled={loading}>
                  Cancelar
                </button>
                <button type="submit" className="btn-primary" disabled={loading || !inputId.trim()}>
                  {loading ? 'Verificando...' : 'Recuperar'}
                </button>
              </div>
            </form>
            <p className="modal-recovery-warning">
              🔒 Não compartilhe seu ID com ninguém. Ele dá acesso total ao seu progresso.
            </p>
          </>
        )}

        {recoveryState.step === 'conflict' && (
          <>
            <h2 className="modal-recovery-title">Qual progresso manter?</h2>
            <p className="modal-recovery-desc">
              Encontramos dados em dois lugares. Escolha qual versão manter:
            </p>
            <div className="modal-recovery-options">
              <button className="recovery-option" onClick={() => onApplyCloud(recoveryState.pendingUserId, recoveryState.cloudAlbums)}>
                <span className="option-icon">☁️</span>
                <span className="option-label">Dados da nuvem</span>
                <span className="option-count">{recoveryState.cloudObtidas} figurinhas obtidas</span>
              </button>
              <button className="recovery-option" onClick={onKeepLocal}>
                <span className="option-icon">📱</span>
                <span className="option-label">Dados deste dispositivo</span>
                <span className="option-count">{recoveryState.localObtidas} figurinhas obtidas</span>
              </button>
            </div>
            <p className="modal-recovery-warning">
              ⚠️ A versão não escolhida será descartada.
            </p>
            <button className="btn-secondary btn-cancel-conflict" onClick={onCancel}>
              Cancelar
            </button>
          </>
        )}

      </div>
    </div>
  );
};

export default ModalRecuperarProgresso;
